import React, { Component } from 'react';
import { DomainPropType, VictoryAxis, VictoryBar, VictoryStack } from 'victory';
import { MeasurementHelper } from '../../lib/helpers/measurementHelper';
import { QualaRange } from '../../lib/qualaRange';
import { variables } from '../utils/Tachyons';
import QualaChart from './QualaChart';

interface ITrafficLightStackedChart {
  helper: MeasurementHelper;
  small?: boolean;
  short?: true;
}

export default class TrafficLightStackedChart extends Component<ITrafficLightStackedChart, {}> {
  public render() {
    const { helper, short = false } = this.props;
    const tickCount = helper.range.timescale === 'month' ? 5 : undefined;
    const domain: DomainPropType = { y: [0, 100] };
    const data = helper.dataForTrafficLightBar();

    return (
      <QualaChart domain={domain} short={short}>
        <VictoryAxis
          tickValues={helper.range.ticks()}
          tickFormat={t => helper.range.formatTick(t)}
          tickCount={tickCount}
          style={{
            grid: { stroke: 'transparent' }
          }}
        />

        {(!!data.red.length || !!data.yellow.length || !!data.green.length) && (
          <VictoryStack>
            {!!data.green.length && (
              <VictoryBar
                data={data.green}
                x="date"
                y="value"
                style={{ data: { fill: variables.green } }}
                animate={{
                  duration: 500,
                  onLoad: { duration: 750 }
                }}
              />
            )}

            {!!data.yellow.length && (
              <VictoryBar
                data={data.yellow}
                x="date"
                y="value"
                style={{ data: { fill: variables.yellow } }}
                animate={{
                  duration: 500,
                  onLoad: { duration: 750 }
                }}
              />
            )}

            {!!data.red.length && (
              <VictoryBar
                data={data.red}
                x="date"
                y="value"
                style={{ data: { fill: variables.red } }}
                animate={{
                  duration: 500,
                  onLoad: { duration: 750 }
                }}
              />
            )}
          </VictoryStack>
        )}
      </QualaChart>
    );
  }
}
